import Spinner from "components/Spinner";

const Fallback = () => {
  return (
    <div className="h-100 d-flex flex-column justify-content-center align-items-center">
      <Spinner />
    </div>
  );
};

export default Fallback;
